import { Action } from 'redux'
import { ServicesModal } from '../../../reducers/bookingCalendar/actionNames'

const toggleServicesModal = (toggle = false): IToggleServicesModal => ({
  toggle,
  type: ServicesModal.ToggleServicesModal,
})

const toggleServicesModalLoading = (
  toggle = false,
): IToggleServicesModalLoading => ({
  toggle,
  type: ServicesModal.ToggleServicesModalLoading,
})

export { toggleServicesModal, toggleServicesModalLoading }

export interface IToggleServicesModal
  extends Action<ServicesModal.ToggleServicesModal> {
  toggle?: boolean
}

export interface IToggleServicesModalLoading
  extends Action<ServicesModal.ToggleServicesModalLoading> {
  toggle?: boolean
}
